import { DayNightLayer as DNL, Twilights } from '@fe/maplibre-extensions';
import React from 'react';
import { UDViewDayNightShadingType, UDViewDayNightTwilightType } from '../../../../udView/udview';
import useMap from '../../../hooks/use-map';
import { useWorkspaceView } from '../hooks/use-view';
import { useSafeEffect } from '../../../hooks/use-safe-effect';
import useTimeNow from '../../../../hooks/use-time-now';

export default function DayNightLayer() {
    const map = useMap();
    const now = useTimeNow({ intervalSeconds: 60});
    const [instance, setInstance] = React.useState<DNL | null>(null);
    const show = useWorkspaceView((x) => x.map.dayNightShading);
    const shadeType = useWorkspaceView((x) => x.map.dayNightShadingType);
    const twilights = useWorkspaceView((x) => x.map.selectedTwilightTypes);

    useSafeEffect(() => {
        if (!map || instance) {
            return;
        }

        const dnl = new DNL('fe-day-night-layer');
        map.addLayer(dnl, 'fe-day-night-slot');

        setInstance(dnl);

        return () => {
            if (map.getLayer('fe-day-night-layer')) {
                map.removeLayer('fe-day-night-layer');
                setInstance(null);
            }
        };
    }, [map]);

    if (!show) {
        instance?.off();
    } else {
        if (shadeType === UDViewDayNightShadingType.shade) {
            instance?.setBasic(0.33);
        } else if (shadeType === UDViewDayNightShadingType.twilight) {
            instance?.updateTwilights(twilightsToString(twilights), 0.11);
        }
        instance?.setTime(new Date(now * 1000));
    }

    return null;
}

function twilightsToString(types: UDViewDayNightTwilightType): Twilights[] {
    const twilights: Twilights[] = [];
    if (types & UDViewDayNightTwilightType.astronomical) {
        twilights.push('astronomical');
    }
    if (types & UDViewDayNightTwilightType.civil) {
        twilights.push('civil');
    }
    if (types & UDViewDayNightTwilightType.nautical) {
        twilights.push('nautical');
    }
    if (types & UDViewDayNightTwilightType.sunrise) {
        twilights.push('sunrise');
    }

    return twilights;
}
